import { Component, OnInit, OnDestroy, Inject, LOCALE_ID, HostListener } from '@angular/core';
import { BlogService } from 'src/app/api/blog.service';
import { BlogPost } from 'src/app/models/blog';
import { Subscription, timer } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'blog-announcments',
  templateUrl: './blog-announcments.component.html',
  styleUrls: ['./blog-announcments.component.scss']
})
export class BlogAnnouncmentsComponent implements OnInit, OnDestroy {
  readonly BLOG_CATEGORY = environment.blog.announcements.category.en;
  readonly BLOG_CATEGORY_AR = environment.blog.announcements.category.ar;
  readonly DURATION = environment.blog.announcements.duration;
  readonly UTM = environment.blog.announcements.utm;

  loading = false;
  data: BlogPost[];
  active = 0;

  timerSubscription: Subscription;

  constructor(private blogService: BlogService, @Inject(LOCALE_ID) public locale: string) { }

  ngOnInit() {
    this.getData();
  }

  ngOnDestroy() {
    this.stopTimer();
  }

  getData() {
    this.loading = true;
    this.blogService.get({
      categories: [this.locale === 'ar' ? this.BLOG_CATEGORY_AR : this.BLOG_CATEGORY],
      limit: 3
    }).subscribe(response => {
      this.loading = false;
      this.data = response.posts;
      this.startTimer();
    }, err => {
      this.loading = false;
      this.data = null;
    });
  }

  startTimer() {
    this.stopTimer();

    this.timerSubscription = timer(this.DURATION).subscribe(() => {
      if (this.active === this.data.length - 1) {
        this.setActive(0);
      } else {
        this.setActive(this.active + 1);
      }
    });
  }

  stopTimer() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }

  setActive(index: number) {
    this.active = index;
    this.startTimer();
  }

  @HostListener('mouseenter')
  onMouseEnter() {
    this.stopTimer();
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.startTimer();
  }
}
